import React, { useContext, useEffect, useState } from "react";
import {
  Table,
  Button,
  Card,
  Space,
  Typography,
  Input,
  Rate,
  Form,
  message,
  Tabs,
  Divider,
  Row,
  Col,
  Tooltip,
} from "antd";
import { DownloadOutlined, UndoOutlined } from "@ant-design/icons";
import { EyeOutlined } from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import { adminService } from "../../_services/admin.service";
import { connect } from "react-redux";
const { Title, Text } = Typography;
const { TextArea } = Input;
const { TabPane } = Tabs;

const FAQ = (props) => {
  const { t } = useContext(LanguageContext);
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const userWiseHelpDesk = () => {
    let obj = { id: props.user.id };
    adminService.userWiseHelpDesk(obj).then((res) => {
      setData(res.data);
    });
  };
  useEffect(() => {
    userWiseHelpDesk();
  }, []);

  const dataSource = [
    {
      key: "1",
      question: t("how_to_fill_accused_info"),
      file: "https://pcimageupload.s3.amazonaws.com/dataEntry-1767170838231.pdf",
    },
    {
      key: "2",
      question: t("section_search_option"),
      file: "https://pcimageupload.s3.ap-south-1.amazonaws.com/CMIS_kayda_sorting.mp4",
    },
    {
      key: "3",
      question: t("how_two_plus_list_generated"),
      file: "https://pcimageupload.s3.ap-south-1.amazonaws.com/plus-1767170701737.pdf",
    },
    {
      key: "4",
      question: t("preventive_action_guidance_benefits"),
      file: "https://pcimageupload.s3.ap-south-1.amazonaws.com/preventive.pdf",
    },
    {
      key: "5",
      question: t("arrested_accused_guidance_benefits"),
      file: "https://pcimageupload.s3.ap-south-1.amazonaws.com/arrest.pdf",
    },
  ];

  const columns = [
    {
      title: t("sr.no"),
      dataIndex: "key",
      key: "key",
      render: (text, record, index) => index + 1,
    },
    {
      title: t("faq"),
      dataIndex: "question",
      key: "question",
    },
    {
      title: t("file"),
      dataIndex: "file",
      key: "file",
      render: (text) => (
        <Button
          type="link"
          icon={<DownloadOutlined />}
          href={text}
          rel="noopener noreferrer"
        ></Button>
      ),
    },
  ];

  const columnsData = [
    {
      title: t("sr.no"),
      dataIndex: "key",
      key: "key",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Suggestion/Feedback",
      dataIndex: "feedback",
      key: "feedback",
      render: (text, record) => (
        <Space size="middle" title={record?.id} style={{ maxWidth: 300 }}>
          {record.feedback ? record.feedback : record.suggestion}
        </Space>
      ),
    },
    {
      title: "Rating",
      dataIndex: "feedback",
      key: "feedback",
      render: (text, record) => <Rate value={record.rating} />,
    },
  ];
  const [suggestionForm] = Form.useForm();
  const [feedbackForm] = Form.useForm();

  const onFinish = (values) => {
    values.user_id = props.user.id;
    console.log("Submitted Data:", values);
    adminService.createHelpDeskFeedback(values).then((res) => {
      if (res.message === "success") {
        message.success("Feedback submitted successfully!");
        feedbackForm.resetFields();
        suggestionForm.resetFields();
      }
    });
  };
  return (
    <>
      <div className="custom-table">
        <Table dataSource={dataSource} columns={columns} pagination={false} />
      </div>

      <div style={{ marginTop: "10px" }}>
        {props?.user?.role != "8" && (
          <>
            {show ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: 12,
                  }}
                >
                  <Tooltip title="Undo">
                    <Button
                      icon={<UndoOutlined />}
                      onClick={() => setShow(!show)}
                      type="default"
                    >
                      Undo
                    </Button>
                  </Tooltip>
                </div>

                <Table
                  dataSource={data}
                  columns={columnsData}                  
                  rowKey="id"
                />
              </>
            ) : (
              <Card
                style={{
                  background: "linear-gradient(135deg, #f0f5ff, #ffffff)",
                  borderRadius: 12,
                  boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                }}
              >
                {/* Helpline */}
                <Title
                  level={5}
                  style={{
                    color: "#4f46e5",
                    textAlign: "center",
                    marginBottom: 8,
                  }}
                >
                  Helpline
                </Title>

                <div style={{ textAlign: "center" }}>
                  <Text
                    strong
                    style={{
                      fontSize: 20,
                      background: "linear-gradient(90deg, #1677ff, #22c55e)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    📞 +91 8984919111
                  </Text>
                  <br />
                  <Text style={{ color: "#6b7280" }}>Time: 10 AM to 8 PM</Text>
                </div>

                <Divider
                  style={{
                    borderColor: "#c7d2fe",
                    margin: "16px 0",
                  }}
                />

                <Row align="middle">
                  <Col span={8} />

                  <Col span={8} style={{ textAlign: "center" }}>
                    <Title level={5} style={{ margin: 0 }}>
                      Suggestions & Feedback
                    </Title>
                  </Col>

                  <Col span={8} style={{ textAlign: "right" }}>
                    <Button type="primary" onClick={() => setShow(!show)}>
                      View history
                    </Button>
                  </Col>
                </Row>

                <Tabs
                  defaultActiveKey="suggestion"
                  centered
                  // tabBarStyle={{
                  //   color: "#4f46e5",
                  //   fontWeight: 600,
                  // }}
                  style={{ marginTop: "10px" }}
                >
                  {/* Suggestion */}
                  <TabPane tab="Suggestion" key="suggestion">
                    <Form
                      form={suggestionForm}
                      layout="vertical"
                      onFinish={(values) =>
                        onFinish({ ...values, type: "suggestion" })
                      }
                    >
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Form.Item
                          label={
                            <Text style={{ color: "#4f46e5" }}>Suggestion</Text>
                          }
                          name="suggestion"
                          rules={[
                            {
                              required: true,
                              message: "Please enter suggestion",
                            },
                          ]}
                        >
                          <TextArea
                            rows={4}
                            placeholder="Enter your suggestion"
                            style={{ borderRadius: 8 }}
                          />
                        </Form.Item>

                        <Button
                          type="primary"
                          htmlType="submit"
                          block
                          style={{
                            borderRadius: 8,
                            background:
                              "linear-gradient(90deg, #4f46e5, #6366f1)",
                            border: "none",
                          }}
                        >
                          Submit Suggestion
                        </Button>
                      </Space>
                    </Form>
                  </TabPane>

                  {/* Feedback */}
                  <TabPane tab="Feedback" key="feedback">
                    <Form
                      form={feedbackForm}
                      layout="vertical"
                      onFinish={(values) =>
                        onFinish({ ...values, type: "feedback" })
                      }
                    >
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Form.Item
                          label={
                            <Text style={{ color: "#4f46e5" }}>Feedback</Text>
                          }
                          name="feedback"
                          rules={[
                            {
                              required: true,
                              message: "Please enter feedback",
                            },
                          ]}
                        >
                          <TextArea
                            rows={4}
                            placeholder="Enter your feedback"
                            style={{ borderRadius: 8 }}
                          />
                        </Form.Item>

                        <Form.Item
                          label={
                            <Text style={{ color: "#4f46e5" }}>Rating</Text>
                          }
                          name="rating"
                          rules={[
                            { required: true, message: "Please give rating" },
                          ]}
                        >
                          <Rate />
                        </Form.Item>

                        <Button
                          type="primary"
                          htmlType="submit"
                          block
                          style={{
                            borderRadius: 8,
                            background:
                              "linear-gradient(90deg, #4f46e5, #6366f1)",
                            border: "none",
                          }}
                        >
                          Submit Feedback
                        </Button>
                      </Space>
                    </Form>
                  </TabPane>
                </Tabs>
              </Card>
            )}
          </>
        )}
      </div>
    </>
  );
};

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedFAQ = connect(mapStateToProps)(FAQ);
export { connectedFAQ as FAQ };
